import React from 'react';
import type { UsTaxImplicationsResult } from '@capintel/instruments-lib';

import ImplicationsSection from './TaxAnalysisImplicationsSections';
import { getShortTermRows, getLongTermRows, getTotalEstimatedTaxesRow, getCarryForwardRows } from './utils/getUsImplicationsRows';

type UsTaxImplicationsTableProps = {
  taxImplications: UsTaxImplicationsResult;
};

const UsTaxImplicationsTable: React.FC<UsTaxImplicationsTableProps> = ({ taxImplications }) => {
  const sections = [
    {
      captionKey: 'Comparison.TaxAnalysis.ImplicationsTable.US.ShortTerm.Header',
      rows: getShortTermRows(),
      key: 'shortTerm',
    },
    {
      captionKey: 'Comparison.TaxAnalysis.ImplicationsTable.US.LongTerm.Header',
      rows: getLongTermRows(),
      key: 'longTerm',
    },
    {
      rows: getTotalEstimatedTaxesRow(),
      key: 'totalEstimatedTaxes',
    },
    {
      captionKey: 'Comparison.TaxAnalysis.ImplicationsTable.US.CarryForward.Header',
      rows: getCarryForwardRows(),
      key: 'carryForward',
    },
  ];

  return (
    <>
      {sections.map(section => (
        <ImplicationsSection key={section.key} captionKey={section.captionKey} rows={section.rows} taxAnalysisData={taxImplications} />
      ))}
    </>
  );
};

export default UsTaxImplicationsTable;
